<div class="popup_header">
    <strong class="popup_title">오아시스마켓 ID <span class="template_url">select-oasis-id-dialog</span></strong>
    <button type="button" class="popup_close" (click)="popupClose()"><span class="blind">팝업 닫기</span></button>
</div>
<div class="popup_content">
    <strong class="desc_center">오아시스마켓 ID를 선택하시겠습니까?</strong>
    <dl class="info_box">
        <div class="dis_flex" *ngFor="let item of oasisIdList">
            <dd>{{item.userId}}</dd>
            <dd style="display:inline-flex;flex:0 0 auto">
                <button type="button" class="btn_item btn_item-sml btn-primary" (click)="selectId(item)">선택</button>
            </dd>
        </div>
    </dl>
</div>
<div class="popup_footer">
    <button type="button" class="btn_item btn-default" (click)="popupClose()">닫기</button>
</div>
